import { createAsyncThunk } from '@reduxjs/toolkit';

import { KhodroHttpGetService } from 'Feature/Khodro/ShakhsSales/Services/KhodroHttpService';
import { _apiPathManagerConfig } from 'Shared/ApiPaths/ApiPathManagerSetup';

import IGetAllAnvaePelakQuery from '../../../../Feature/Khodro/Common/Queries/IGetAllAnvaePelakQuery';

export const getAllAnvaePelak = createAsyncThunk('AnvaePelak/GetAll', async (query: IGetAllAnvaePelakQuery) => {
  return await KhodroHttpGetService({
    url: `${_apiPathManagerConfig?.Khodro.AnvaePelak.GetAllAnvaePelakByNoeVasilehNaghlieh}`,
    params: query,
  });
});
